import React, { useEffect, useState } from 'react'
import { Image, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import { api_gateway } from '../../../conexoes/api'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import {
  elipseAmarelo,
  elipseAzul,
  elipseVerde,
  elipseVermelho
} from '../../../utils/alternanciaIcones'
import { formatarData } from '../../../utils/formatadorDataTabela'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
import Table from '../../Table/index.jsx'
import DetalhamentoSolicitacaoOperadora from '../detalhamentoSolicitacao/operadora/tabela'

import FinalizarAtendimento from './finalizarAtendimento/finalizarAtendimento'
import NovaSolicitacao from './novaSolicitacao/novaSolicitacao'
import ReenviarEmail from './reenviarEmail/reenviarEmail'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let dadosSelecionados = []
let itensVar = []
const valorLimite = 50

const TableprimaryKey = 'CD_SOLICITACAO'

function TabelaClientesAcoes() {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [itens, setItens] = useState([])
  const [linhasReenvioSolicitacao, setLinhasReenvioSolicitacao] = useState([])
  const [solicitacaoReenvioSolicitacao, setSolicitacaoReenvioSolicitacao] =
    useState({})
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)

  const [solicitacaoModalTxt, setSolicitacaoModalTxt] = useState(
    'reenvio da solicitação'
  )

  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [
    revelarMensagemAtencaoReenviarSolicitacao,
    setRevelarMensagemAtencaoReenviarSolicitacao
  ] = useState(false)
  const [
    revelarMensagemAtencaoParcialReenviarSolicitacao,
    setRevelarMensagemAtencaoParcialReenviarSolicitacao
  ] = useState(false)
  const [
    revelarMensagemSucessoSolicitacaoReenvio,
    setRevelarMensagemSucessoSolicitacaoReenvio
  ] = useState(false)
  const [
    revelarMensagemErroSolicitacaoReenvio,
    setRevelarMensagemErroSolicitacaoReenvio
  ] = useState(false)
  const [itensSelecionados, setItensSelecionados] = useState([])

  const despacho = useDispatch()

  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let novaSolicitacao = useSelector(
    (state) => state.virtueyesState.novaSolicitacaoVirtueyes
  )
  let reenviarEmailVirtueyes = useSelector(
    (state) => state.virtueyesState.reenviarEmailVirtueyes
  )
  let confimarRecebimentoVirtueyes = useSelector(
    (state) => state.virtueyesState.confimarRecebimentoVirtueyes
  )

  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  //   let revelarLogReset = useSelector(
  //     (state) => state.virtueyesState.revelarLogReset
  //   )

  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(430) // 'solicitacaoOperadoraTabela'
      setColetaUsabilidade(false)
    }
  }, [])

  useEffect(() => {
    restaurarConfigsIniciaisPagina()
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(limpadorFiltros(true))
  }, [])

  useEffect(() => {
    setSpinAtivo(true)
    despacho(desabilitarAcoes(true))
    despacho(desabilitarAcoesCliente(true))
    despacho(mudarManejador('solicitacaoOperadora'))
    async function carregarTabela() {
      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/solicitacao?painel_virtueyes=true&fl_operadora=1&paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite +
              '&buscar=' +
              conteudoBusca
          )
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paginaAtual: contador,
          carregarLimit: valorLimite,
          fl_operadora: 1,
          buscar: conteudoBusca,
          filtros: filtros,
          painel_virtueyes: true
        }

        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post(
            '/m1/filtrar/solicitacao',
            dados
          )
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/solicitacao?painel_virtueyes=true&fl_operadora=1&paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite
          )
          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, filtros, renderizar])

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    dadosSelecionados = []
    despacho(desabilitarAcoes(true))
    setPaginaAtual(1)
  }

  function handleSelecionarTodos() {
    ColetaClickstream(436) // 'solicitacaoOperadoraTabelaHandleSelecionarTodos'
    itens.map((item, i) => {
      if (itens[i].CD_SOLICITACAO) {
        dadosSelecionados.push(itens[i].CD_SOLICITACAO)
      }
    })
    despacho(desabilitarAcoes(false))
  }

  function handleDesselecionarTodos() {
    ColetaClickstream(437) // 'solicitacaoOperadoraTabelaHandleDesselecionarTodos'
    dadosSelecionados = []
    despacho(desabilitarAcoes(true))
  }

  function handleSelecionar(simcard) {
    ColetaClickstream(438) // 'solicitacaoOperadoraTabelaHandleSelecionar'
    for (let i = 0; i < itens.length; i++) {
      if (itens[i].CD_SOLICITACAO == simcard) {
        dadosSelecionados.push(itens[i].CD_SOLICITACAO)
        break
      }
    }
    despacho(desabilitarAcoes(false))
  }

  function handleDesselecionar(simcard) {
    ColetaClickstream(439) // 'solicitacaoOperadoraTabelaHandleDesselecionar'
    for (let i = 0; i < dadosSelecionados.length; i++) {
      if (dadosSelecionados[i] == simcard) {
        dadosSelecionados.splice(i, 1)
        break
      }
    }
    if (dadosSelecionados.length == 0) {
      despacho(desabilitarAcoes(true))
    }
  }

  const colunas = [
    {
      dataField: 'CD_SOLICITACAO',
      headerClasses: 'nao-selecionavel',
      text: 'ID',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'DS_OPERADORA',
      headerClasses: 'nao-selecionavel',
      text: 'Operadora',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'DATA_CRIACAO',
      headerClasses: 'nao-selecionavel',
      text: 'Data',
      sort: true,
      formatter: (cell) => {
        return formatarData(cell)
      }
    },
    {
      dataField: 'ORIGEM',
      headerClasses: 'nao-selecionavel',
      text: 'Origem',
      sort: true,
      formatter: (cell, row) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {row.ds_status_api != null ? 'Automação' : 'NAT'}
          </p>
        )
      }
    },
    {
      dataField: 'DESC_SOLICITACAO',
      headerClasses: 'nao-selecionavel',
      text: 'Descrição',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'DESC_STATUS_SOLICITACAO',
      headerClasses: 'nao-selecionavel',
      text: 'Status',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'OPERADORA_PROTOCOLO',
      headerClasses: 'nao-selecionavel',
      text: 'Protocolo operadora',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' && cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'ds_status_api',
      headerClasses: 'nao-selecionavel',
      text: 'Status API',
      sort: true,
      formatter: (cell, row) => {
        if (cell != '' && cell != undefined) {
          if (cell == 'Parcial') {
            return (
              <OverlayTrigger
                delay={{ show: 500, hide: 250 }}
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-bottom">Refazer solicitação</Tooltip>
                }
              >
                <button
                  className="fonte-cor-1 label-tabela-1 btn-status-tabela-erro"
                  onClick={() => handleReenviarSolicitacao(row)}
                >
                  {' '}
                  <Image
                    className="img-eclipse-status"
                    src={elipseAmarelo()}
                  />{' '}
                  {cell}{' '}
                </button>
              </OverlayTrigger>
            )
          } else if (cell == 'Retornado') {
            return (
              <p className="fonte-cor-1 label-tabela-1">
                <Image className="img-eclipse-status" src={elipseVerde()} />{' '}
                {cell}
              </p>
            )
          } else if (cell == 'Enviado') {
            return (
              <p className="fonte-cor-1 label-tabela-1">
                <Image className="img-eclipse-status" src={elipseAzul()} />{' '}
                {cell}
              </p>
            )
          } else {
            return (
              <OverlayTrigger
                delay={{ show: 500, hide: 250 }}
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-bottom">Refazer solicitação</Tooltip>
                }
              >
                <button
                  className="fonte-cor-1 label-tabela-1 btn-status-tabela-erro"
                  onClick={() => handleReenviarSolicitacao(row)}
                >
                  {' '}
                  <Image
                    className="img-eclipse-status"
                    src={elipseVermelho()}
                  />{' '}
                  {cell}{' '}
                </button>
              </OverlayTrigger>
            )
          }
        } else {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        }
      }
    }
  ]

  function getSolModalTxt(desc) {
    let auxTxt
    if (desc) {
      const strRetirar = 'Solicitação de'
      auxTxt = desc
      if (desc.indexOf(strRetirar) > -1) {
        auxTxt = desc.substr(strRetirar.length + 1, desc.length)
      }
    } else {
      auxTxt = 'reenvio da solicitação'
    }

    return `"${auxTxt}"`
  }

  async function handleReenviarSolicitacao(solicitacao) {
    if (!solicitacao) return
    const { CD_SOLICITACAO, CD_TIPO_SOLICITACAO } = solicitacao

    setSpinAtivo(true)

    const queryString =
      'cd_crm_solicitacao_operadora=' +
      CD_SOLICITACAO +
      '&cd_crm_solicitacao_tipo=' +
      CD_TIPO_SOLICITACAO +
      '&erradas=true'

    const dataPeriodo = await api_gateway.get(
      '/m1/consultar/solicitacao_simcard/api_simcards?' + queryString
    )
    setSpinAtivo(false)

    if (dataPeriodo.data.dados != undefined) {
      setLinhasReenvioSolicitacao(dataPeriodo.data.dados)
      setSolicitacaoReenvioSolicitacao(solicitacao)
      setSolicitacaoModalTxt(getSolModalTxt(solicitacao.DESC_SOLICITACAO))
      setRevelarMensagemAtencaoReenviarSolicitacao(true)
    } else {
      setRevelarMensagemErroSolicitacaoReenvio(true)
    }
  }

  function handleMensagemAtencaoReenviarSolicitacao(confirmacao) {
    if (revelarMensagemAtencaoReenviarSolicitacao === false) {
      setRevelarMensagemAtencaoReenviarSolicitacao(true)
    } else {
      setRevelarMensagemAtencaoReenviarSolicitacao(false)
    }
    if (confirmacao) {
      reenviarSolicitacao()
    }
  }

  async function handleMensagemAtencaoParcialReenviarSolicitacao(confirmacao) {
    if (revelarMensagemAtencaoParcialReenviarSolicitacao === false) {
      setRevelarMensagemAtencaoParcialReenviarSolicitacao(true)
    } else {
      setRevelarMensagemAtencaoParcialReenviarSolicitacao(false)
    }
    if (confirmacao) {
      await handleAtualizarStatusSolicitacao()
      setRenderizar(!renderizar)
    }
  }

  async function handleMensagemSucessoSolicitacaoReenvio(confirmacao) {
    if (revelarMensagemSucessoSolicitacaoReenvio === false) {
      setRevelarMensagemSucessoSolicitacaoReenvio(true)
    } else {
      setRevelarMensagemSucessoSolicitacaoReenvio(false)
    }
    if (confirmacao) {
      await handleAtualizarStatusSolicitacao()
      setRenderizar(!renderizar)
    }
  }

  function handleMensagemErroSolicitacaoReenvio() {
    if (revelarMensagemErroSolicitacaoReenvio === false) {
      setRevelarMensagemErroSolicitacaoReenvio(true)
    } else {
      setRevelarMensagemErroSolicitacaoReenvio(false)
    }
  }

  // TODO: refatorar (código repetido)
  const refazerSolicitacao = async function (linha) {
    let bodySolicitacao = {
      operadora: linha.OPERADORA,
      tecnologia: linha.TECNOLOGIA,
      cd_crm_solicitacao_tipo:
        solicitacaoReenvioSolicitacao.CD_TIPO_SOLICITACAO,
      cd_crm_solicitacao: linha.CD_SOLICITACAO_OPERADORA,
      cd_crm_solicitacao_simcard: linha.CD_SOLICITACAO_SIMCARD,
      reenvio: true
    }
    if (linha.OPERADORA == 'VIVO') {
      bodySolicitacao.iccid = linha.ICCID
    } else if (linha.OPERADORA == 'TIM') {
      bodySolicitacao.linha = linha.LINHA
    } else if (linha.OPERADORA == 'NEO') {
      // Virtueyes/Telecall
      let msisdnStr = linha.LINHA.toString()
      let msisdn = linha.LINHA

      if (msisdnStr.length > 11 && msisdnStr.substr(0, 2) == '55') {
        msisdn = parseInt(msisdnStr.slice(2, msisdnStr.length))
      }
      bodySolicitacao.linha = msisdn
    }

    const retornoSolicitacao = await api_gateway
      .post('/m1/cadastrar/solicitacao/operadora', bodySolicitacao)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error.response
      })

    if (retornoSolicitacao.status == 200) {
      return true
    } else {
      return false
    }
  }

  async function reenviarSolicitacao() {
    setSpinAtivo(true)

    const resultado = await Promise.all(
      linhasReenvioSolicitacao.map((linha) => refazerSolicitacao(linha))
    )

    if (resultado.every(checkArrayTrue)) {
      setRevelarMensagemSucessoSolicitacaoReenvio(true)
      setSpinAtivo(false)
    } else {
      setRevelarMensagemAtencaoParcialReenviarSolicitacao(true)
      setSpinAtivo(false)
    }
  }

  function checkArrayTrue(e) {
    return e == true
  }

  async function handleAtualizarStatusSolicitacao() {
    if (!solicitacaoReenvioSolicitacao) return
    const { CD_SOLICITACAO, CD_TIPO_SOLICITACAO } =
      solicitacaoReenvioSolicitacao
    let queryString =
      'cd_crm_solicitacao_operadora=' +
      CD_SOLICITACAO +
      '&cd_crm_solicitacao_tipo=' +
      CD_TIPO_SOLICITACAO
    const consultaSolicitacao = await api_gateway.get(
      '/m1/consultar/solicitacao_simcard/api_simcards?' + queryString
    )

    if (consultaSolicitacao.data.status == 200) {
      let erros = 0
      let retornados = 0
      let enviados = 0
      let statusSolicitacao = 1
      let status = ''

      consultaSolicitacao.data.dados.map((simcard) => {
        const statusSolicitacao = simcard.STATUS_API
        if (statusSolicitacao == 'Erro') {
          erros++
        } else if (statusSolicitacao == 'Retornado') {
          retornados++
        } else if (statusSolicitacao == 'Enviado') {
          enviados++
        }
      })

      let tamanhoArray = consultaSolicitacao.data.dados.length
      if (erros == tamanhoArray) {
        status = 'Erro'
      } else if (retornados == tamanhoArray) {
        status = 'Retornado'
        statusSolicitacao = 2
      } else if (enviados == tamanhoArray) {
        status = 'Enviado'
      } else {
        status = 'Parcial'
      }

      await api_gateway.post('/m1/alterar/solicitacao', {
        dados: {
          ds_status_api: status,
          cd_crm_solicitacao_status: statusSolicitacao
        },
        condicao: {
          cd_crm_solicitacao: solicitacaoReenvioSolicitacao.CD_SOLICITACAO
        }
      })
    }
  }

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData
    if (controladorPagina <= paginaAtual) {
      if (controladorPagina <= paginaAtual && filtros.vazio) {
        apiData = await api_gateway.get(
          '/m1/consultar/solicitacao?painel_virtueyes=true&fl_operadora=1&contar=true&buscar=' +
            conteudoBusca
        )
      } else {
        const dados = {
          paginaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros,
          fl_operadora: 1,
          painel_virtueyes: true,
          contar: true
        }
        apiData = await api_gateway.post('/m1/filtrar/solicitacao', dados)
      }
      itensVar = []
      if (apiData.data.dados) {
        totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
        totalItens = apiData.data.dados[0].CONTADOR
        for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
          arrayItens.push(i)
        }
        itensVar = arrayItens
      }
    }
  }

  const renderDetalhamentoLinha = (row) => {
    return (
      <div className="container-row-expand-central-acoes-solicitacao-operadora">
        <DetalhamentoSolicitacaoOperadora
          cdSolicitacao={row.CD_SOLICITACAO}
          cdTipoSolicitacao={row.CD_TIPO_SOLICITACAO}
          descSolicitacao={row.DESC_SOLICITACAO}
          refazerSolicitacao={refazerSolicitacao}
          getSolModalTxt={getSolModalTxt}
          razaoSocial={row.RAZAO_SOCIAL}
          nomeFantasia={row.NOME_FANTASIA}
          renderizar
        />
      </div>
    )
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setItensSelecionados((prev) => [...prev, row[TableprimaryKey]])

      handleSelecionar(row.CD_SOLICITACAO)
    } else {
      setItensSelecionados((prev) =>
        prev.filter((id) => id !== row[TableprimaryKey])
      )
      handleDesselecionar(row.CD_SOLICITACAO)
    }
  }

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      const allIds = rows.map((r) => r[TableprimaryKey])
      setItensSelecionados((prev) => [...prev, ...allIds])

      handleSelecionarTodos()
    } else {
      setItensSelecionados((prev) =>
        prev.filter((id) => !rows.some((r) => r[TableprimaryKey] === id))
      )
      handleDesselecionarTodos()
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  return (
    <div className="container-tela">
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        permissaoDetalhamentoLinha
        detalhamentLinha={renderDetalhamentoLinha}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados,
          modeSelection: 'checkbox',
          handleOnSelect,
          handleOnSelectAll
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}

      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={() =>
                setRevelarMensagemErro(!revelarMensagemErro)
              }
              mensagemTitulo="Erro"
              mensagemParagrafo1="Ocorreu um erro. Tente novamente mais tarde."
              mensagemParagrafo2="Caso o erro persista, entre em contato com o Suporte."
              mensagemParagrafo3="Ocorreu um erro ao executar esta ação"
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencaoReenviarSolicitacao && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              handleMensagemAtencao={handleMensagemAtencaoReenviarSolicitacao}
              mensagemTitulo="Atenção"
              mensagemParagrafo2={`Deseja mesmo refazer o ${solicitacaoModalTxt} das`}
              mensagemParagrafo3="linhas com erro nesta solicitação?"
              mensagemBotao="Confirmar"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencaoParcialReenviarSolicitacao && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              handleMensagemAtencao={
                handleMensagemAtencaoParcialReenviarSolicitacao
              }
              mensagemTitulo="Atenção"
              mensagemParagrafo2={`Não foi possível efetuar o ${solicitacaoModalTxt}`}
              mensagemParagrafo3="para todas as linhas da solicitação"
              mensagemBotao="Confirmar"
            />
          </div>
        </div>
      )}
      {revelarMensagemSucessoSolicitacaoReenvio && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucessoSolicitacaoReenvio}
              mensagemTitulo="Sucesso!"
              mensagemParagrafo1={`${solicitacaoModalTxt} efetuado`}
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      {revelarMensagemErroSolicitacaoReenvio && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={() => handleMensagemErroSolicitacaoReenvio}
              mensagemTitulo="Erro"
              mensagemParagrafo1="Não foi possível reenviar"
              mensagemParagrafo2={`o ${solicitacaoModalTxt} das linhas`}
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      {novaSolicitacao === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <NovaSolicitacao
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {confimarRecebimentoVirtueyes === true && (
        <FinalizarAtendimento
          renderizar={renderizar}
          setRenderizar={setRenderizar}
          itensSelecionados={dadosSelecionados}
        />
      )}
      {reenviarEmailVirtueyes === true && (
        <ReenviarEmail
          renderizar={renderizar}
          setRenderizar={setRenderizar}
          itensSelecionados={dadosSelecionados}
        />
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}

export default connect(mapStateToProps)(React.memo(TabelaClientesAcoes))
